export default "__VITE_ASSET__CNpe9PkP__"